module.exports = __webpack_public_path__ + "img/图标1.10340c52.png";